import './App.css';
import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider} from 'react-router-dom';
import {useState} from 'react';
import React from 'react';
import { ErrorBoundary } from "react-error-boundary";
//components
import Header from './com/header/Header';
import Layout from './com/Layout';
import DaySheet from './com/daySheet/DaySheet';
import Calendar from './com/calendar/Calendar';
import Modal from './com/modal/Modal';

//pages
import Approval, {approvalDetailsLoader} from './pages/approval/Approval';
import PDFfile, {approvedDetailsLoader} from './pages/pdf/PDF';
import AdminView, {adminDetailsLoader} from './pages/admin/AdminView';
import NotFound from './pages/notFound/notFound';

function App() {
  
  const [selectedDate, setDate] = useState(new Date()); 
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let monthIndex = (selectedDate.getMonth());
  let monthName = monthNames[monthIndex];
  let month = monthName.substring(0,3);
  let year = (selectedDate.getFullYear());
  const [employeeEmail, setEmail] = useState();
  const [employeeDetails, setEmployeeDetails] = useState();
  const [previewStatus, setPreviewStatus] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const router = createBrowserRouter(
    createRoutesFromElements(
      
        <Route path="/" element={<Layout/>}> 
          <Route path="/" element={<>
                                     <Header/>
                                     <Calendar selectedDate={selectedDate} setDate={setDate}/>
                                     <DaySheet selectedDate={selectedDate} employeeEmail={employeeEmail} 
                                      employeeDetails={employeeDetails} setEmployeeDetails={setEmployeeDetails} setEmail={setEmail} month={month} year={year}
                                      previewStatus={previewStatus} setPreviewStatus={setPreviewStatus} />
                                     <Modal selectedDate={selectedDate} employeeEmail={employeeEmail} month={month} year={year} employeeDetails={employeeDetails} 
                                     previewStatus={previewStatus} setModalOpen={setModalOpen} modalOpen={modalOpen}/>
                                  </>}/>
          <Route path="/approval/:key/:employeeEmail/:month/:year" element={<><Header/><Approval/></>} loader={approvalDetailsLoader}/>
          <Route path="/approved/:employeeEmail/:month/:year" element={<PDFfile/>} loader={approvedDetailsLoader}/>
          <Route path="/admin/view" element={<AdminView/>} loader={adminDetailsLoader}/>
          <Route path="*" element={<><Header/><NotFound/></>}/>
          {/* possible non restricted feature under login/profile pretense */}
        </Route>
    )
  )
  return (
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <RouterProvider router={router}/>
    </ErrorBoundary>
  );
}

export default App;
